// extracted by mini-css-extract-plugin
export default {"root":"style_root__AncVq","dealt":"style_dealt__7cmLj"};